import {
	Group,
	MantineSpacing,
	MantineThemeComponent,
	StyleProp,
	useProps,
} from "@mantine/core";
import React from "react";

interface Props {
	children?: React.ReactNode;
	style?: StyleProp<React.CSSProperties>;
}

interface StyleProps {
	w: StyleProp<React.CSSProperties["width"]>;
	h: StyleProp<React.CSSProperties["width"]>;
	justify: React.CSSProperties["justifyContent"];
	wrap: React.CSSProperties["flexWrap"];
	p: StyleProp<MantineSpacing>;
}

const defaultStyleProps: StyleProps = {
	w: "100%",
	h: "100%",
	justify: "center",
	wrap: "nowrap",
	p: "xs",
};

export type AppBuilderHorizontalContainerThemePropsType = Partial<StyleProps>;

export function AppBuilderHorizontalContainerThemeProps(
	props: AppBuilderHorizontalContainerThemePropsType,
): MantineThemeComponent {
	return {
		defaultProps: props,
	};
}

/**
 * Vertical container for AppBuilder
 * @param props
 * @returns
 */
export default function AppBuilderHorizontalContainer(
	props: Props & Partial<StyleProps>,
) {
	const {children, ...rest} = useProps(
		"AppBuilderHorizontalContainer",
		defaultStyleProps,
		props,
	);

	return <Group {...rest}>{children}</Group>;
}
